<template>
  <div>
    <div
      class="tag-group"
      :style="
        `left:${note.x - padding / 2}px; width: ${bound.width + padding}px; top: ${note.y -
          topPadding / 2}px; height: ${bound.height + padding * 2}px;`
      "
      @mouseenter="setState('hoveringTag', note)"
      @mouseleave="setState('hoveringTag', false)"
      @mousedown.stop="dragStart"
    >
      <div @dblclick.stop.prevent="setupEditing">
        <embedded-card-content
          class="tag-group-title"
          ref="cardContent"
          :page="page"
          :pageId="page.id"
          :parentPageId="container.pageId"
          :nested="false"
          :card="true"
          :showSectionify="true"
          :userCanEdit="true"
          :renderEditable="true"
          :clickToEdit="!editing"
          @blur="editing = false"
          @deleteNote="removeNotePages({ noteId: note.id, pageId: container.pageId })"
        ></embedded-card-content>
      </div>
      <!-- <div class="tag-group-title">
        <v-text-field
          ref="titleInput"
          autofocus
          v-model="title"
          solo
          flat
          background-color="transparent"
          @keypress.enter="$refs.titleInput.blur()"
          @dblclick.stop
          @click.stop
          @mousedown.stop
        >
          <template v-slot:prepend>
            <v-btn icon @mousedown.stop.prevent="dragStart">
              <v-icon>drag_handle</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </div> -->
    </div>
    <item-card
      v-for="note in pageNotes"
      ref="cards"
      v-bind="$props"
      :note="note"
      :key="note.id"
      :container="{ pageId: page.id }"
      :inSection="true"
      :style="`${dragOutCard && dragOutCard.id == note.id ? 'opacity: 0;' : ''}'`"
    >
    </item-card>
  </div>
</template>

<script>
import cardTypes from '../PageTypeIcon/cardTypes';
import { ref, computed, inject, watch } from '@vue/composition-api';
import { pagesModule } from '@/store/database/pagesModule';
import { updateNote } from '../use/useDocActions';
import ItemCard from './ItemCard';

export default {
  props: ['note', 'container'],
  components: {
    ItemCard,
    EmbeddedCardContent: () => import('@/components/ContextDoc/EmbeddedCardContent')
  },
  setup(props) {
    const ideaBoard = inject('ideaBoard');
    const { state, setState, setDragStart, updateCardPositions, handleDragEnd } = ideaBoard;
    const colIndex = inject('colIndex');

    const page = pagesModule.doc(props.note.pageId).data;
    const pageNotes = computed({
      get() {
        console.log('compute tag page notes');
        const page = pagesModule.doc(props.note.pageId).data;
        return Object.values(page.pageNotes)
          .filter(p => !p.toDelete && p.id != undefined)
          .sort((a, b) => (a.order > b.order ? 1 : -1));

        // return notes.map((n, i) => ({ x: 0, y: i * 100 + 30, ...n }));
      },
      set(v) {
        console.log('set computed', v);
      }
    });

    const childrenLength = computed(() => {
      return pageNotes.value.length;
    });

    function stripHTML(textToStrip) {
      var div = document.createElement('div');
      div.innerHTML = textToStrip;
      return div.textContent || div.innerText || '';
    }

    const selected = computed(
      () => !!state.selectedCardRefs.value.find(s => s.note.id == props.note.id)
    );
    const isContainer = ref(!!childrenLength.value && !props.nested);

    const hoveringContainer = computed(() => {
      return (
        isContainer.value &&
        state.hoverContainer.value &&
        state.hoverContainer.value.id == props.note.id &&
        !state.hoverPage.value &&
        state.draggingCard.value &&
        state.draggingCard.value.id != props.note.id
      );
    });

    const icon = computed(() => {
      return cardTypes.find(c => c.note == page.icon);
    });

    const title = computed({
      get() {
        return stripHTML(page.title);
      },
      set() {
        console.log('set title');
      }
    });

    const showNotePage = ref(false);

    const getBounds = cardRefs => {
      console.log('get bounds');
      let lefts = [],
        tops = [],
        rights = [],
        bottoms = [];
      cardRefs.forEach(c => {
        lefts.push(c.note.x);
        tops.push(c.note.y);
        rights.push(c.note.x + c.$el.clientWidth);
        bottoms.push(c.note.y + c.$el.clientHeight);
      });
      const bound = {
        x: Math.min(...lefts),
        y: Math.min(...tops),
        width: Math.max(...rights) - Math.min(...lefts),
        height: Math.max(...bottoms) - Math.min(...tops)
      };
      if (bound.x !== props.note.x || bound.y !== props.note.y) {
        //  update actual note position
        const update = { x: bound.x, y: bound.y };
        updateNote({ pageId: props.container.pageId, noteId: props.note.id, update });
      }
      return bound;
    };

    const noteBounds = computed(() => {
      console.log('note bounds');
      const notes = pageNotes.value;
      return notes.map(n => ({ x: n.x, y: n.y }));
    });

    const bound = ref({ x: 0, y: 0, w: 100, h: 100 });

    return {
      icon,
      colIndex,
      setState,
      setDragStart,
      updateCardPositions,
      handleDragEnd,
      title,
      showNotePage,
      page,
      pageNotes,
      isContainer,
      childrenLength,
      hoveringContainer,
      selected,
      bound,
      noteBounds,
      getBounds,
      ...state
    };
  },
  data() {
    return {
      padding: 40,
      topPadding: 100,
      dragging: false,
      editing: false,
      bound: { x: this.note.x || 0, y: this.note.y || 0, w: 100, h: 100 },
      startPos: {
        view: {
          // relative to viewport
          x: 0,
          y: 0
        },
        cards: [],
        canvas: {
          //  relative to canvas position
          x: 0,
          y: 0
        },
        scale: 1
      }
    };
  },
  mounted() {
    const cardRefs = this.$refs.cards;
    let b = { x: 0, y: 0, w: 100, h: 100 };
    if (this.pageNotes && cardRefs) {
      if (cardRefs.length) {
        b = this.getBounds(cardRefs);
      }
    }
    this.bound = b;
  },
  beforeDestroy() {
    this.setState('hoveringTag', false);
  },
  watch: {
    noteBounds() {
      console.log('watch bounds');
      const cardRefs = this.$refs.cards;
      let b = { x: 0, y: 0, w: 100, h: 100 };
      if (!this.dragging && this.pageNotes && cardRefs) {
        if (cardRefs.length) {
          b = this.getBounds(cardRefs);
        }
      }
      this.bound = b;
    },
    childrenLength() {
      //  if we added or removed a child, resize the box
      this.$nextTick(() => {
        let b = { x: 0, y: 0, w: 100, h: 100 };
        const cardRefs = this.$refs.cards;
        if (this.pageNotes && cardRefs) {
          if (cardRefs.length) {
            b = this.getBounds(cardRefs);
          }
        }
        this.bound = b;
      });
    }
    // pageNotes(val) {
    //   console.log('watch pageNotes');
    //   const notes = this.pageNotes;
    //   const cardRefs = this.$refs.cards;
    //   if (notes.length && cardRefs) {
    //     if (cardRefs.length) {
    //       let lefts = [],
    //         tops = [],
    //         rights = [],
    //         bottoms = [];
    //       cardRefs.forEach(c => {
    //         lefts.push(c.note.x);
    //         tops.push(c.note.y);
    //         rights.push(c.note.x + c.$el.clientWidth);
    //         bottoms.push(c.note.y + c.$el.clientHeight);
    //       });
    //       this.bound = {
    //         x: Math.min(...lefts),
    //         y: Math.min(...tops),
    //         width: Math.max(...rights) - Math.min(...lefts),
    //         height: Math.max(...bottoms) - Math.min(...tops)
    //       };
    //     }
    //     if (this.bound.x !== this.note.x || this.bound.y !== this.note.y) {
    //       //  update actual note position
    //       const update = { x: this.bound.x, y: this.bound.y };
    //       updateNote({ pageId: this.container.pageId, noteId: this.note.id, update });
    //     }
    //   }
    // }
  },
  computed: {
    // bound() {
    //   console.log(this.$refs, this);
    //   const notes = this.pageNotes;
    //   const cardRefs = this.$refs.cards;
    //   let bound = { x: this.note.x || 0, y: this.note.y, w: 100, h: 100 };
    //   if (notes.length && cardRefs) {
    //     if (cardRefs.length) {
    //       let lefts = [],
    //         tops = [],
    //         rights = [],
    //         bottoms = [];
    //       cardRefs.forEach(c => {
    //         lefts.push(c.note.x);
    //         tops.push(c.note.y);
    //         rights.push(c.note.x + c.$el.clientWidth);
    //         bottoms.push(c.note.y + c.$el.clientHeight);
    //       });
    //       bound = {
    //         x: Math.min(...lefts),
    //         y: Math.min(...tops),
    //         width: Math.max(...rights) - Math.min(...lefts),
    //         height: Math.max(...bottoms) - Math.min(...tops)
    //       };
    //     }
    //     if (bound.x !== this.note.x || bound.y !== this.note.y) {
    //       //  update actual note position
    //       const update = { x: bound.x, y: bound.y };
    //       updateNote({ pageId: this.container.pageId, noteId: this.note.id, update });
    //     }
    //   }
    //   return bound;
    // }
  },
  methods: {
    setupEditing() {
      this.editing = true;
      this.$nextTick(() => {
        this.$refs.cardContent.traverseIn({});
      });
    },
    dragStart(e) {
      this.pz.pause();
      let cards = [];
      this.pageNotes.forEach(c => {
        cards.push({ id: c.id, x: c.x, y: c.y });
      });
      this.dragging = true;
      this.startPos = {
        view: {
          x: e.x,
          y: e.y
        },
        canvas: {
          x: this.note.x,
          y: this.note.y
        },
        cards,
        scale: this.pz.getTransform().scale
      };
      document.addEventListener('mousemove', this.updatePos);
      document.addEventListener('mouseup', this.dragEnd);
    },
    dragEnd() {
      this.dragging = false;
      // this.$emit('dragEnd');
      document.removeEventListener('mousemove', this.updatePos);
      document.removeEventListener('mouseup', this.dragEnd);
      this.pz.resume();
    },
    updatePos(e) {
      const { scale, view, cards, canvas } = this.startPos;
      const changeLeft = e.x - view.x;
      // const left = canvas.x + changeLeft / scale;
      const changeTop = e.y - view.y;
      //const right = canvas.y + changeTop / scale;
      updateNote({
        pageId: this.container.pageId,
        noteId: this.note.id,
        update: { x: canvas.x + changeLeft / scale, y: canvas.y + changeTop / scale }
      });
      cards.forEach(c => {
        const update = {
          x: c.x + changeLeft / scale,
          y: c.y + changeTop / scale
        };
        updateNote({ pageId: this.note.pageId, noteId: c.id, update });
      });
      // this.$emit('updateTagPosition', newCardPositions);
    }
  }
};
</script>

<style>
.tag-group {
  position: absolute;
  background: #bababa38;
  border: 1px solid #e3e3e3;
}

.tag-group-title {
  /* position: absolute;
  top: -45px;
  left: 5px; */
  width: 100%;
}
</style>
